export const ShareIconColored = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3334 13.2543C10.4514 13.4476 10.5914 13.6305 10.7535 13.7992C11.7598 14.8464 13.2935 15.0101 14.4647 14.2903C14.6817 14.1569 14.8862 13.9932 15.0727 13.7992L17.7722 10.9897C18.9649 9.74834 18.9649 7.73578 17.7722 6.49446C16.5795 5.25315 14.6457 5.25315 13.453 6.49446L12.8584 7.1133"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.142 17.3466L10.5471 17.9657C9.35442 19.207 7.42064 19.207 6.22792 17.9657C5.03519 16.7243 5.03519 14.7118 6.22791 13.4705L8.92743 10.661C10.1202 9.41965 12.0539 9.41965 13.2467 10.661C13.4087 10.8296 13.5487 11.0125 13.6667 11.2057"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default ShareIconColored;
